
export interface SkyscannerSuggest {
    PlaceId?: string;
    PlaceName?: string;
    LocalizedPlaceName?: string;
    CountryId?: string;
    CityId?: string;
    IataCode?: string;
    CountryName?: string;
    PlaceNameEn?: string;
    RegionId?: string;
    CityName?: string;
    CityNameEn?: string;
    GeoId?: string;
    GeoContainerId?: string;
    Location?: string;
    ResultingPhrase?: string;
    UntransliteratedResultingPhrase?: string;
    Highlighting?: number[][];
}

export interface SkyscannerSuggestResponse {
    places: SkyscannerPlace[]
}

export interface SkyscannerDistance {
    value: number;
    unitCode: string;
}

export interface AirportInformation {
    iataCode: string;
    name: string;
    countryId: string;
    cityId: string;
    entityId: string;
    parentId: string;
    distance: SkyscannerDistance;
    location: string;
}

export interface SkyscannerPlace {
    entityId: string;
    iataCode?: string;
    parentId: string;
    name: string;
    countryId: string;
    countryName: string;
    cityName: string;
    location: string;
    hierarchy: string;
    type: SkyscannerPlaceType;
    highlighting: number[][];
    airportInformation?: AirportInformation;
}

export enum SkyscannerPlaceType {
    country = 'PLACE_TYPE_COUNTRY',
    airport = 'PLACE_TYPE_AIRPORT',
    city = 'PLACE_TYPE_CITY'
}
